/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IMediaModel, useIsLoggedIn } from "@nf/common";
import { useTranslation } from "next-i18next";

import Button, { type ButtonVariant, type ButtonSize } from "components/Button";
import { useFavoriteToggle, useSyncCompleted } from "hooks";

import XIcon from "resources/icons/x.svg";
import PlusIcon from "resources/icons/plus.svg";

interface MyListButtonProps {
  text?: string;
  secondaryText?: string;
  media: IMediaModel;
  size?: ButtonSize;
  variant?: ButtonVariant;
}

export const MyListButton = ({
  text,
  secondaryText,
  media,
  size = "large",
  variant = "secondary",
}: MyListButtonProps) => {
  const { t } = useTranslation("translations");
  const { isFavorite, toggleFavorite, canFavorite } = useFavoriteToggle(media);
  const isLoggedIn = useIsLoggedIn();
  const isAuthProcessCompleted = useSyncCompleted();

  const addFavorite = text ?? t("web_highlight_asset_button_add_to_list");
  const removeoFavorite =
    secondaryText ?? t("web_highlight_asset_button_remove_from_list");

  if (!isLoggedIn || !canFavorite) {
    return null;
  }

  return (
    <Button
      size={size}
      variant={variant}
      icon={isFavorite ? <XIcon /> : <PlusIcon />}
      onClick={toggleFavorite}
      state={isAuthProcessCompleted ? "default" : "skeleton"}
    >
      {isFavorite ? removeoFavorite : addFavorite}
    </Button>
  );
};

export default MyListButton;
